import React from "react";
import parse from "html-react-parser";
import ThemeButton from "../../component/button/button";

const scrollToSection = (sectionId) => {
  const target = document.getElementById(sectionId);
  if (!target) {
    return;
  }

  const y = target.getBoundingClientRect().top + window.pageYOffset - 96;
  window.scrollTo({ top: y, behavior: "smooth" });
};

const Aboutme = ({ content, services = [] }) => {
  return (
    <section id="my_about_list" className="space-y-8">
      <div className="grid gap-6 lg:grid-cols-[1.2fr_0.8fr]">
        <div className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8">
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            {content.location} • {content.availability}
          </p>
          <h1 className="max-w-3xl font-display text-4xl font-bold leading-tight text-skin-text md:text-6xl">
            {content.headline}
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-8 text-skin-muted md:text-lg">
            {content.short_description}
          </p>

          <div className="mt-6 flex flex-wrap gap-3">
            {content.focus_areas?.map((item) => (
              <span
                key={item}
                className="rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm text-skin-text"
              >
                {item}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-4 sm:flex-row">
            <ThemeButton
              text={content.primary_cta ?? "View Projects"}
              onClick={() => scrollToSection("my_projects_list")}
            />
            <button
              type="button"
              className="rounded-full border border-white/15 bg-white/10 px-6 py-4 text-sm font-medium text-skin-text transition hover:bg-white/15"
              onClick={() => scrollToSection("my_contact_list")}
            >
              {content.secondary_cta ?? "Contact Me"}
            </button>
          </div>
        </div>

        <div className="rounded-[2rem] border border-white/15 bg-white/10 p-4 shadow-glass backdrop-blur-xl">
          <div className="relative overflow-hidden rounded-[1.75rem] bg-black/20">
            <img
              src={content.main_image}
              alt={content.name}
              className="h-full min-h-[380px] w-full object-cover"
            />
            <div className="absolute inset-x-4 bottom-4 rounded-[1.5rem] border border-white/20 bg-black/30 p-4 backdrop-blur-xl">
              <p className="text-sm uppercase tracking-[0.28em] text-skin-accentSoft">
                {content.title}
              </p>
              <h2 className="mt-2 font-display text-2xl font-semibold text-white">
                {content.name}
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {content.metrics?.map((item) => (
          <div
            key={item.label}
            className="rounded-[1.75rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl"
          >
            <div className="font-display text-3xl font-bold text-skin-text">
              {item.value}
            </div>
            <div className="mt-2 text-sm uppercase tracking-[0.22em] text-skin-muted">
              {item.label}
            </div>
          </div>
        ))}
      </div>

      <div className="grid gap-6 lg:grid-cols-[0.95fr_1.05fr]">
        <div className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            About Me
          </p>
          <div className="space-y-5 text-base leading-8 text-skin-muted">
            {parse(content.description)}
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {services.map((service) => (
            <div
              key={service.title}
              className="rounded-[1.75rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl"
            >
              <p className="text-xs font-semibold uppercase tracking-[0.28em] text-skin-accentSoft">
                {service.kicker}
              </p>
              <h3 className="mt-3 font-display text-2xl font-semibold text-skin-text">
                {service.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-skin-muted">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Aboutme;
